module.exports = __webpack_public_path__ + "static/media/Testimonial-Logo.b904a3c5.jpeg";